import { render, staticRenderFns } from "./RegisterAccount.vue?vue&type=template&id=0bbe5fc1&scoped=true"
import script from "./RegisterAccount.vue?vue&type=script&lang=js"
export * from "./RegisterAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe5fc1",
  null
  
)

export default component.exports